import {getAccountsUsersCountByState} from 'src/openapi/admin/apis/AccountsUsersCountsApi';
import {UserState} from 'src/openapi/admin/models/UserState';
import {useAppDispatch} from 'src/store/hooks';

import {COLUMNS} from '../../../constants';

type Props = {
    data: Record<string, string>[],
    selectedColumns: string[],
    accountIds: number[],
    nameToIdsMap: Record<string, number>,
    apiDispatch: ReturnType<typeof useAppDispatch>,
};

export const fetchUsersCountByState = async (props: Props): Promise<Record<string, string>[] | null> => {
    const {data, selectedColumns, accountIds, nameToIdsMap, apiDispatch} = props;

    const userStates = [
        [UserState.LICENSED, COLUMNS.LICENSED_ENABLED_USERS],
        [UserState.MOBILE, COLUMNS.MOBILE_ENABLED_USERS],
        [UserState.CRM_ONLY, COLUMNS.CRM_ENABLED_USERS],
        [UserState.DISABLED, COLUMNS.DISABLED_NEWSLETTER_USERS],
        [UserState.NO_ACCESS, COLUMNS.NO_ACCESS_USERS],
        [UserState.CONFERENCE, COLUMNS.CONFERENCE_USERS],
        [UserState.CREDIT_ALERTS, COLUMNS.CREDIT_ALERTS_ENABLED_USERS],
    ] as const;

    let newData = [...data];

    for (const [state, column] of userStates) {
        if (!selectedColumns.includes(column)) {
            continue;
        }

        const response = await apiDispatch(getAccountsUsersCountByState({
            getAccountsUsersCountsByStateRequest: {
                accountIds: [...new Set(accountIds)],
                userState: state,
            },
        }));

        if (!response.payload.success) {
            return null;
        }

        const stateCounts = response.payload.data;
        newData = newData.map(row => {
            const accountId = nameToIdsMap[row[COLUMNS.ACCOUNT_NAME]];
            return {
                ...row,
                [column]: String(stateCounts[accountId] ?? ''),
            };
        });
    }

    return newData;
};
